import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import GlobalStyles from './styles/GlobalStyles';
import Header from './components/Header';
import Home from './pages/Home';
import Login from './pages/Login';
import Upload from './pages/Upload';
import UploadVideo from './pages/UploadVideo';
import ProfileView from './pages/ProfileView';
import ProfileForm from './pages/ProfileForm';
import Admin from './pages/Admin';
import AdminTools from './pages/AdminTools';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/ProtectedRoute';
import Footer from './components/Footer';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import theme from './styles/theme';

// Componente para controlar la visibilidad del Header
const HeaderControl = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';
  
  return !isLoginPage ? <Header /> : null;
};

function App() {
  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <GlobalStyles />
          <HeaderControl />
          <Box sx={{ minHeight: '100vh' }}>
            <Routes>
              {/* Redirigir la ruta principal a login */}
              <Route path="/" element={<Navigate to="/login" replace />} />
              
              {/* Ruta de login pública */}
              <Route path="/login" element={<Login />} />
              
              {/* Ruta de galería principal protegida */}
              <Route path="/gallery" element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              } />
              
              {/* Rutas de perfil protegidas */}
              <Route path="/profile/:profileId" element={
                <ProtectedRoute>
                  <ProfileView />
                </ProtectedRoute>
              } />
              
              {/* Creación de perfil protegida */}
              <Route path="/create-profile" element={
                <ProtectedRoute>
                  <ProfileForm />
                </ProtectedRoute>
              } />
              
              {/* Edición de perfil solo para admin o propietario */}
              <Route path="/edit-profile/:profileId" element={
                <ProtectedRoute ownerOnly>
                  <ProfileForm />
                </ProtectedRoute>
              } />
              
              {/* Subida de imágenes protegida */}
              <Route path="/upload" element={
                <ProtectedRoute>
                  <Upload />
                </ProtectedRoute>
              } />
              
              {/* Subida de videos protegida */}
              <Route path="/upload-video" element={
                <ProtectedRoute>
                  <UploadVideo />
                </ProtectedRoute>
              } />
              
              {/* Rutas de administración solo para admin */}
              <Route path="/admin" element={
                <ProtectedRoute adminOnly>
                  <Admin />
                </ProtectedRoute>
              } />
              <Route path="/admin/tools" element={
                <ProtectedRoute adminOnly>
                  <AdminTools />
                </ProtectedRoute>
              } />
              
              {/* Ruta 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Box>
          {/* Footer temporalmente oculto
          <Footer />
          */}
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
